import React, { useEffect, useRef, useState } from 'react';
import { Platform, TextInput, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import { getShadowThemeStyles, isDarkTheme } from '@/constants/Colors';
import ChatInputSendButton from '@/components/ChatInput/ChatInputSendButton';
import { observeTextareaWidth, resizeComposerTextarea } from '@/components/ChatInput/textareaLayout';
import { isComposerEnterEvent } from '@/constants/utils/composerEnter';

export default function BotSetupComposer({ value, onChangeText, onSend, busy, maxLength, label, placeholder, maxInputHeight = 240 }) {
  const { colors, theme } = useTheme();
  const themeStyles = getShadowThemeStyles(theme);
  const input = useRef(null);
  const [height, setHeight] = useState(46);
  const disabled = busy || !value.trim();
  useEffect(() => {
    if (Platform.OS === 'web' && input.current) resizeComposerTextarea(input.current);
  }, [value]);
  useEffect(() => {
    if (Platform.OS !== 'web' || !input.current) return undefined;
    return observeTextareaWidth(input.current, () => resizeComposerTextarea(input.current));
  }, []);
  return <View style={{
    borderRadius: 24, borderWidth: 1, borderColor: themeStyles.borderColor,
    backgroundColor: Platform.OS === 'macos' ? colors.solid_color_block : themeStyles.backgroundColor,
    overflow: 'hidden', minHeight: 86,
    ...(Platform.OS === 'web' ? { backdropFilter: 'blur(18px) saturate(1.8)', WebkitBackdropFilter: 'blur(18px) saturate(1.8)', boxShadow: isDarkTheme(theme) ? themeStyles.boxShadow : 'none' } : {}),
  }}>
    <TextInput ref={input} value={value} onChangeText={onChangeText} maxLength={maxLength}
      editable={!busy} multiline accessibilityLabel={label} placeholder={placeholder}
      placeholderTextColor={themeStyles.placeholderColor}
      style={{ color: colors.text_color_primary, backgroundColor: 'transparent', fontSize: 17, lineHeight: 24,
        paddingVertical: 12, paddingLeft: 16, paddingRight: 16, minHeight: 46, maxHeight: maxInputHeight,
        borderWidth: 0, textAlignVertical: 'top',
        ...(Platform.OS === 'web' ? { outlineStyle: 'none', resize: 'none' } : { height: Math.min(height, maxInputHeight) }),
      }}
      onContentSizeChange={Platform.OS !== 'web' ? e => setHeight(Math.max(46, e.nativeEvent.contentSize.height)) : undefined}
      onKeyPress={Platform.OS === 'web' ? e => {
        if (isComposerEnterEvent(e) && !e.shiftKey && !e.nativeEvent?.shiftKey) {
          e.preventDefault();
          if (!disabled) onSend();
        }
      } : undefined}
    />
    <View style={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', height: 40, paddingHorizontal: 6, paddingBottom: 6 }}>
      <ChatInputSendButton onPress={onSend} isDisabled={disabled} isLoading={busy} />
    </View>
  </View>;
}
